var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeMenu,
          expression: "closeMenu",
        },
      ],
      ref: "pix-navbar-menu-item",
      staticClass: "pix-navbar-menu-item__item",
      class: {
        "pix-navbar-menu-item__item--has-separator": _vm.menuItem.hasSeparator,
        "pix-navbar-menu-item__item--parent": _vm.isFirstItem,
        "pix-navbar-menu-item__item--open": _vm.isFirstItem && _vm.isOpen,
      },
      on: {
        click: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "left", 37, $event.key, [
              "Left",
              "ArrowLeft",
            ])
          )
            return null
          if ("button" in $event && $event.button !== 0) return null
          return _vm.handleClick(_vm.menuItem)
        },
        mouseup: function ($event) {
          if ("button" in $event && $event.button !== 1) return null
          return _vm.handleClick(_vm.menuItem)
        },
      },
    },
    [
      !_vm.isFirstItem &&
      _vm.hasChildren &&
      _vm.expandDirection === _vm.ExpandDirections.Left
        ? _c("span", {
            staticClass: "pix-navbar-menu-item__icon mdi mdi-menu-right",
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.menuItem.imgSource
        ? _c(
            "span",
            { staticClass: "pix-navbar-menu-item__image" },
            [_c("pix-flag", { attrs: { country: _vm.menuItem.imgSource } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.menuItem.route
        ? _c(
            "router-link",
            {
              staticClass: "pix-navbar-menu-item__label",
              attrs: { to: _vm.menuItem.route },
            },
            [_vm._v("\n    " + _vm._s(_vm.translation) + "\n  ")]
          )
        : _c(
            "span",
            {
              staticClass: "pix-navbar-menu-item__label",
              class: { "pix-navbar-menu-item__label--bold": _vm.boldLabel },
            },
            [_vm._v("\n    " + _vm._s(_vm.translation) + "\n  ")]
          ),
      _vm._v(" "),
      _vm.isFirstItem && _vm.hasChildren
        ? _c("span", {
            staticClass: "pix-navbar-menu-item__icon mdi mdi-menu-down",
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isFirstItem &&
      _vm.hasChildren &&
      _vm.expandDirection === _vm.ExpandDirections.Right
        ? _c("span", {
            staticClass: "pix-navbar-menu-item__icon mdi mdi-menu-left",
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.displayLogout
        ? [
            _c("span", { staticClass: "mdi mdi-account" }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.userName))]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.hasChildren && ((_vm.isFirstItem && _vm.isOpen) || !_vm.isFirstItem)
        ? _c(
            "ul",
            {
              staticClass: "pix-navbar-menu-item__submenu",
              class: {
                "pix-navbar-menu-item__submenu--first-submenu": _vm.isFirstItem,
                "pix-navbar-menu-item__submenu--left":
                  _vm.expandDirection === _vm.ExpandDirections.Left,
                "pix-navbar-menu-item__submenu--right":
                  _vm.expandDirection === _vm.ExpandDirections.Right,
              },
            },
            _vm._l(_vm.menuItem.children, function (children) {
              return _c("pix-navbar-menu-item", {
                key: children.label,
                attrs: {
                  "menu-item": children,
                  "expand-direction": _vm.expandDirection,
                },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.menuItem.hasSeparator
        ? _c("div", { staticClass: "pix-navbar-menu-item__separator" })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }